import React, { Component } from "react";

class TermAndCondition extends Component {
  render() {
    return (
      <div className="ltn__contact-address-area mb-90 mt-120">
        <div className="container">
          <div className="row">
            <ol>
              <li>
                <strong>INTRODUCTION</strong>
                <ul>
                  <li>
                    <strong>Who we are</strong>. We are ZELLE LTD , a limited
                    company incorporated in UK with company number 13742020 .The
                    registered office for the company is Birtles Farm Hocker
                    Lane, Over Alderley, Macclesfield, SK10 4SB. The Usee-360
                    brand was established by Zelle Ltd .As a brand , Usee-360 is
                    brand recognized internationally, Usee Portal company
                    incorporated in Dubai / UAE, License No 1166569.
                  </li>
                  <li>
                    <strong>How to contact us</strong>. You can contact our
                    customer service team by emailing us at &nbsp;
                    <a href="info@usee-360.com">info@usee-360.com</a>.
                  </li>
                  <li>
                    <strong>How we may contact you</strong>. . If we have to
                    contact you we will do so by writing to you at the email
                    address you provided to us during registration.
                  </li>
                  <li>
                    <strong>“Writing” includes emails</strong>. When we use the
                    words “writing” or “written” in these terms, this includes
                    emails.
                  </li>
                </ul>
              </li>
              <li>
                <strong>OUR TERMS</strong>
                <ul>
                  <li>
                    <strong>What these terms cover</strong>. These terms and
                    conditions (“<strong>terms</strong>”) set out the terms on
                    which we provide access to our U-See mobile application (“
                    <strong>our app</strong>”) and our website &nbsp;
                    <a href="https://usee360.com/">https://usee360.com/</a>{" "}
                    &nbsp; (the term “<strong>our site</strong>” refers to the
                    website and our app) which you use or through which you
                    access our services.
                  </li>
                  <li>
                    <strong>Why you should read them</strong>. Please read these
                    terms carefully before you use our site or our services.
                    These terms tell you who we are, and other important
                    information. If you think that there is a mistake in these
                    terms, please contact us to discuss.
                  </li>
                  <li>
                    <strong>Acceptance of these terms</strong>. By using our
                    site, you confirm that you accept these terms and that you
                    agree to comply with them. If you do not agree to these
                    terms, you must not use our site or services. We recommend
                    that you print a copy of these terms for future reference.
                  </li>
                  <li>
                    <strong>There are other terms that may apply to you</strong>
                    . Our Privacy Policy and our Cookie Policy also apply to
                    your use of our site and our use of your personal
                    information. Our Privacy Policy and Cookie Policy are
                    incorporated into these terms.
                  </li>
                  <li>
                    <strong>We may make changes to these terms.</strong> We
                    amend these terms from time to time. Every time you wish to
                    use our site, please check these terms to ensure you
                    understand the terms that apply at that time.
                  </li>
                  <li>
                    <strong>We may make changes to our site.</strong> We may
                    update and change our site from time to time to reflect
                    changes to our services, our users needs and our business
                    priorities. We will try to give you reasonable notice of any
                    major changes.
                  </li>
                  <li>
                    <strong>We may suspend or withdraw our site.</strong> Our
                    site is made available free of charge. We do not guarantee
                    that our site, or any content on it, will always be
                    available or be uninterrupted. We may suspend or withdraw or
                    restrict the availability of all or any part of our site for
                    business and operational reasons. We will try to give you
                    reasonable notice of any suspension or withdrawal. You are
                    also responsible for ensuring that all persons who access
                    our site through your internet connection are aware of these
                    terms of use and other applicable terms and conditions, and
                    that they comply with them.
                  </li>
                </ul>
              </li>
              <li>
                <strong>OUR SITE TO BE USED BY</strong>
                <ul>
                  <li><strong>International users.</strong> Currently in UK and MENA.
                  </li>
                </ul>
              </li>
              <li>
                <strong>OUR RELATIONSHIP WITH YOU</strong>
                <ul>
                  <li>
                    <strong>Our objective.</strong> Our purpose is to provide a
                    link between you, potential buyers and those you represent
                    to engage in online visual real-time property viewings.
                  </li>
                  <li>
                    <strong>
                      No legal contract between us for supply and purchase of
                      products.
                    </strong>
                    You acknowledge that the legal contract for supply and
                    purchase of the properties which are viewed is between you
                    and the buyer and seller and we are only supplying our
                    service to assist you with that process.
                  </li>
                </ul>
              </li>
              <li>
                <strong>YOUR ACCOUNT AND THE TERM OF OUR AGREEMENT WITH YOU</strong>
                <ul>
                  <li>
                    <strong>Setting up an account.</strong> In order to allow
                    your properties to be viewed through our site, you will need
                    to set up an account with us. You can do this &nbsp;
                    <a href="https://usee360.com/customer/register">here</a>
                  </li>
                  <li>
                    The agreement between us will be for a minimum period of 30
                    days. Once that period has run you may terminate your
                    agreement with us.
                  </li>
                  <li>
                    <strong>You must keep your account details safe.</strong> If
                    you choose, or you are provided with, a user identification
                    code, password or any other piece of information as part of
                    our security procedures, you must treat such information as
                    confidential. You must not disclose it to any third party.
                    If you know or suspect that anyone other than you knows your
                    user identification code or password, you must promptly
                    notify us at &nbsp;
                    <a href="mailto:info@usee-360.com">info@usee-360.com</a>.
                  </li>
                  <li>
                    <strong>We may disable your account.</strong> We have the
                    right to disable any user identification code or password,
                    whether chosen by you or allocated by us, at any time, if in
                    our reasonable opinion
                  </li>
                  <li>
                    <strong>Direct debit payments.</strong> You agree to set up
                    a direct debit payment with us to make the payments you have
                    agreed to pay to us under this agreement.
                  </li>
                </ul>
              </li>
              <li>
                <strong>PRICE AND PAYMENT</strong>
                <ul>
                  <li>
                    <strong>Monthly Free Units</strong>
                    <br />
                    <ul>
                      <li>At ZELLE LTD, we are excited to offer our users monthly free
                    units, which can be applied to access certain features
                    within our U-See mobile application and website. These free
                    units are credited to your account each month, providing you
                    with complimentary access to select services and
                    functionalities.
                    </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Usee-Coin: In-App Currency</strong>
                    <br />
                    <ul>
                      <li>To enhance our user experience, we have introduced
                    Usee-Coin, our exclusive in-app currency. Usee-Coin can be
                    used to purchase additional units beyond the free monthly
                    allocation, enabling access to premium features within our
                    app and website.
                    </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Purchasing Usee-Coin</strong>
                    <br />
                    <ul>
                      <li>
                        Usee-Coin can be purchased directly within the U-See
                        mobile application or on our website.
                      </li>
                      <li>
                        All purchases of Usee-Coin are required to be made in
                        advance. Once your payment is processed, the
                        corresponding amount of Usee-Coin will be credited to
                        your account immediately.
                      </li>
                      <li>
                        The rate at which units can be redeemed using Usee-Coin 
                        will be clearly stated within the app and on our
                        website.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Usage of Units</strong>
                    <br/>
                    <ul>
                      <li>
                      Units, whether obtained through monthly free allocations or purchased 
                      via Usee-Coin, can be used to access various features within our platform. 
                      Detailed information on how units can be used will be provided within the 
                      app and on our website.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Refunds and Cancellations</strong>
                    <br/>
                    <ul>
                      <li>Purchases of Usee-Coin are final and only refundable under extreme 
                        circumstances. You can contact support for queries regarding refunds. 
                        Usee-Coin cannot be exchanged back for cash or credited back to your 
                        payment method under any circumstances.
                      </li>
                      <li>
                      Unused monthly free units will not carry over to the next month; they 
                      will expire at the end of each billing cycle.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Changes to Payment Terms</strong>
                    <br/>
                    <ul>
                      <li>
                      ZELLE LTD reserves the right to modify the pricing, the allocation of 
                      monthly free units, and the terms related to Usee-Coin at any time. Any 
                      changes will be effective immediately upon posting in the updated 
                      Terms & Conditions on our website and mobile application. Your continued 
                      use of our services after such changes will constitute your acceptance of 
                      the new terms.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <strong>INFORMATION ON OUR SITE</strong>
                <ul>
                  <li>
                    <strong>How you may use material on our site.</strong>
                  </li>
                    <ul>
                      <li>
                      <p>
                      We are the owner or the licensee of all intellectual property
                      rights in our site, and in the material published on it.&nbsp;
                      Those works are protected by copyright laws and treaties around
                      the world. All such rights are reserved.
                      </p>
                      </li>
                    </ul>
                    <ul>
                      <li>
                      <p>
                      You may print off one copy, and may download extracts, of any
                      page(s) from our site for your personal use and you may draw the
                      attention of others within your organisation to content posted on
                      our site.
                      </p>
                      </li>
                    </ul>
                    <ul>
                      <li>
                      <p>
                      You must not modify the paper or digital copies of any materials
                      you have printed off or downloaded in any way, and you must not
                      use any illustrations, photographs, video or audio sequences or
                      any graphics separately from any accompanying text.
                      </p>
                      </li>
                    </ul>
                    <ul>
                      <li>
                      <p>
                      Our status (and that of any identified contributors) as the
                      authors of content on our site must always be acknowledged.
                      </p>
                      </li>
                    </ul>
                    <ul>
                      <li>
                      <p>
                      You must not use any part of the content on our site for
                      commercial purposes without obtaining a licence to do so from us
                      or our licensors.
                      </p>
                      </li>
                    </ul>
                    <ul>
                      <li>
                      <p>
                      If you print off, copy or download any part of our site in breach
                      of these terms of use, your right to use our site will cease
                      immediately and you must, at our option, return or destroy any
                      copies of the materials you have made.
                      </p>
                      </li>
                    </ul>
                </ul>
                <ul>
                  <li>
                    <strong>Do not rely on information on this site.</strong>
                    <ul>
                      <li>
                      The content on our site (including user reviews) is provided for general
                      information only. It is not intended to amount to advice on
                      which you should rely. You must obtain professional or
                      specialist advice before taking, or refraining from, any action
                      on the basis of the content on our site. We disclaim all
                      liability and responsibility arising from any reliance placed on
                      such materials by you, or by anyone who may be informed of any
                      of its contents.
                      </li>
                    </ul>
                    <ul>
                      <li>
                      <p>
                      Although we make reasonable efforts to update the information on
                      our site, we make no representations, warranties or guarantees,
                      whether express or implied, that the content on our site is
                      accurate, complete or up to date.
                      </p>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul>
                  <li>
                  <strong>We are not responsible for viruses and you must not introduce them.
                  </strong>
                    <ul>
                      <li>We do not guarantee that our site will be secure or free from
                        bugs or viruses. You are responsible for configuring your
                        information technology, computer programs and platform to access
                        our site. You should use your own virus protection software.
                        </li>
                    </ul>
                    <ul>
                      <li>
                      You must not misuse our site by knowingly introducing viruses,
                      trojans, worms, logic bombs or other material that is malicious or
                      technologically harmful. You must not attempt to gain unauthorised
                      access to our site, the server on which our site is stored or any
                      server, computer or database connected to our site. You must not
                      attack our site via a denial-of-service attack or a distributed
                      denial-of service attack. By breaching this provision, you would
                      commit a criminal offence under the Computer Misuse Act 1990. We
                      will report any such breach to the relevant law enforcement
                      authorities and we will co-operate with those authorities by
                      disclosing your identity to them. In the event of such a breach,
                      your right to use our site will cease immediately.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <strong>USER CONTENT AND REVIEWS</strong>
                <ul>
                  <li>
                    <strong>User-generated content is not approved by us.</strong> Our site may
                    include information and materials uploaded by other users of
                    the site, including reviews from other users. This
                    information and these materials have not been verified or
                    approved by us. The views expressed by other users on our
                    site do not represent our views or values.
                  </li>
                  <li>
                    <strong>How to complain about content uploaded by other users.</strong>
                    If you wish to complain about content uploaded by other
                    users please contact us at &nbsp;
                    <a href="info@usee-360.com">info@usee-360.com</a>.
                  </li>
                  <li>
                    <strong>You must comply with our content standards.</strong>
                    Whenever you make use of a feature that allows you to upload
                    content to our site, such content must be accurate (where it
                    states facts), be genuinely held where it states opinions
                    and must comply with the law applicable in England and Wales
                    and in any country from which it is posted and must be a
                    genuine representation of the property to be viewed in each
                    case. The content must not:
                    <ul>
                      <li>Be defamatory of any person.</li>
                      <li>Be obscene, offensive, hateful or inflammatory.</li>
                      <li>Bully, insult, intimidate or humiliate.</li>
                      <li>Promote sexually explicit material.</li>
                      <li>Promote violence.</li>
                      <li>
                        Promote discrimination based on race, sex, religion,
                        nationality, disability, sexual orientation or age.
                      </li>
                      <li>
                        Infringe any copyright, database right or trade mark of any
                        other person.
                      </li>
                      <li>Be likely to deceive any person.</li>
                      <li>
                        Breach any legal duty owed to a third party, such as a
                        contractual duty or a duty of confidence.
                      </li>
                      <li>Promote any illegal activity.</li>
                      <li>Be in contempt of court.</li>
                      <li>
                        Be threatening, abuse or invade another’s privacy, or cause
                        annoyance, inconvenience or needless anxiety.
                      </li>
                      <li>
                        Be likely to harass, upset, embarrass, alarm or annoy any other
                        person.
                      </li>
                      <li>
                        Impersonate any person, or misrepresent your identity or
                        affiliation with any person.
                      </li>
                      <li>
                        Give the impression that the content emanates from us, if this
                        is not the case.
                      </li>
                      <li>
                        Advocate, promote, incite any party to commit, or assist any
                        unlawful or criminal act such as (by way of example only)
                        copyright infringement or computer misuse.
                      </li>
                      <li>
                        Contain a statement which you know or believe, or have
                        reasonable grounds for believing, that members of the public to
                        whom the statement is, or is to be, published are likely to
                        understand as a direct or indirect encouragement or other
                        inducement to the commission, preparation or instigation of acts
                        of terrorism.
                      </li>
                      <li>
                        Contain any advertising or promote any services or web links to
                        other sites.
                      </li>
                    </ul>
                    <p>
                        We have the right to remove any posting you make or content you
                        upload on our site if, in our opinion, your post does not comply
                        with the content standards set out above.
                    </p>
                  </li>
                  <li>
                    <li>
                      <strong>Your warranty to us.</strong> You warrant and represent
                      that any content that you upload does comply with the standards
                      set out above, and you will be liable to us and indemnify us for
                      any breach of that warranty or representation. This means you
                      will be responsible for any loss or damage we suffer as a result
                      of your breach of warranty or representation.
                    </li>
                    <li>
                      <strong>Rights in your content.</strong> Any content you upload
                      to our site will be considered non-confidential and
                      non-proprietary. You retain all of your ownership rights in your
                      content, but you are required to grant us and other users of our
                      site a limited licence to use, store and copy that content and
                      to distribute and make it available to third parties. You agree
                      that we are free to copy, disclose, distribute, incorporate and
                      otherwise use any user content and all data, images, sounds,
                      text and other things embodied in it for any and all commercial
                      or non-commercial purposes. To the extent that such material is
                      protected by intellectual property rights, you grant us a
                      perpetual, worldwide, royalty-free licence to use, copy, modify,
                      distribute, sell and disclose to third parties any such material
                      or data for any purpose related to our business You are solely
                      responsible for securing and backing up your content.
                    </li>
                    <li>
                      <strong>Disclosing your identity.</strong> We have the right to
                      disclose your identity to any third party who is claiming that
                      any content posted or uploaded by you to our site constitutes a
                      violation of their intellectual property rights, or of their
                      right to privacy.
                    </li>
                  </li>
                </ul>
              </li>
              <li>
                <strong>LINKS TO AND FROM OTHER WEBSITES</strong>
                <ul>
                  <li>
                    <strong>
                      We are not responsible for websites we link to.{" "}
                    </strong>
                    Where our site contains links to other sites and resources
                    provided by third parties, these links are provided for your
                    information only. Such links should not be interpreted as
                    approval by us of those linked websites or information you
                    may obtain from them. We have no control over the contents
                    of those sites or resources.
                  </li>
                  <li>
                    <strong>Rules about linking to our site</strong>
                    <ul>
                      <li>
                      <p>
                        You may link to our home page, provided you do so in a way that is 
                        fair and legal and does not damage our reputation or take 
                        advantage of it.
                      </p>
                      </li>
                      <li>
                      <p>
                        You must not establish a link in such a way as to suggest any form
                        of association, approval or endorsement on our part where none
                        exists.
                      </p>
                      </li>
                      <li>
                      <p>
                        You must not establish a link to our site in any website that is
                        not owned by you.
                      </p>
                      </li>
                      <li>
                      <p>
                        Our site must not be framed on any other site, nor may you create
                        a link to any part of our site other than the home page.
                      </p>
                      </li>
                      <li>
                      <p>
                        We reserve the right to withdraw linking permission without
                        notice.
                      </p>
                      </li>
                      <li>
                      <p>
                        The website in which you are linking must comply in all respects
                        with the content standards set out above.
                      </p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <strong>TERMINATION</strong>
                <ul>
                  <li>
                    <strong>
                      We may terminate your use of the site if you breach the
                      terms
                    </strong>
                    . We may terminate or suspend (at our absolute discretion
                    and not limiting any other remedies that we may have) your
                    use of the site at any time by writing to you if:
                    <ul>
                      <li>
                        you do not make any payment to us when it is due and you
                        still do not make payment within 7 days of us reminding
                        you that payment is due;
                      </li>
                      <li>
                        we believe that you have used the site in breach of
                        clause 7 (Information on our site), clause 8 (User
                        Content and Reviews), or clause 9 (Links to and from
                        other websites); or
                      </li>
                      <li>
                        we believe that you have breached any other material
                        terms of these terms.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <strong>OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU</strong>
                <ul>
                  <li>
                    <strong>
                      We are responsible to you for foreseeable loss and damage
                      caused by us
                    </strong>
                    . We are responsible to you for any loss or damage that you
                    suffer that is a foreseeable result of our breaking these
                    terms. We are not responsible for any loss or damage that is
                    not foreseeable. Loss or damage is foreseeable if either it
                    is obvious that it will happen or if, at the time the
                    contract was made, both we and you knew it might happen.
                  </li>
                  <li>
                    <strong>
                      We do not exclude or limit in any way our liability to you
                      where it would be unlawful to do so
                    </strong>
                    . This includes liability for death or personal injury
                    caused by our negligence or the negligence of our employees,
                    agents or subcontractors; for fraud or fraudulent
                    misrepresentation; or any other liability which cannot be
                    excluded or limited under applicable law. Nothing in these
                    terms affects your statutory rights.
                  </li>
                  <li>
                    <strong>We are not liable for business losses</strong>. If
                    you are a consumer please note that we only provide our site
                    for domestic and private use. You agree not to use our site
                    for any commercial or business purposes. If you do use our
                    site for any commercial, business or re-sale purpose our
                    liability to you will be limited as set out in clause 4.
                  </li>
                  <li>
                    <strong>
                      Our responsibility for loss or damage suffered by you if
                      you are a business.
                    </strong>
                    If you are not a consumer, subject to clause 2:
                    <ul>
                      <li>
                        we shall not be liable to you, whether in contract, tort
                        (including negligence), breach of statutory duty, or
                        otherwise, even if it is foreseeable, arising under or
                        in connection with:
                      </li>
                      <li>
                        use of, or inability to use our site; or
                      </li>
                      <li>
                        use of, or reliance on any content displayed on our site.
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>< br></br>In particular, we will not be liable for:</p>
                <ul>
                  <li>any loss of profit, sales, business or revenue;</li>
                  <li>loss or corruption of data, information or software;</li>
                  <li>loss of business opportunity, goodwill or reputation;</li>
                  <li>loss of anticipated savings;</li>
                  <li>or any indirect or consequential loss or damage; and</li>
                  <li>
                    our total liability to you for all other losses arising under or
                    in connection with any contract between us, whether in contract,
                    tort (including negligence), breach of statutory duty, or
                    otherwise, shall be limited to 0.
                  </li>
                </ul>
              </li>
              <li>
                <strong>OTHER IMPORTANT TERMS</strong>
                <ul>
                  <li>
                    <strong>Events outside of our control.</strong> We will not
                    be in breach of any contract or be liable for any failure to
                    perform, or delay in performance of, any of our obligations
                    under these terms that is caused by events or circumstances
                    outside our reasonable control.
                  </li>
                  <li>
                    <strong>How we will use your personal information</strong>.
                    We will only use your personal information as set out in our
                    Privacy Policy.
                  </li>
                  <li>
                    <strong>
                      We may transfer this Agreement to someone else
                    </strong>
                    . We may transfer our rights and obligations under these
                    terms to another organisation without your consent.
                  </li>
                  <li>
                    <strong>
                      You need our consent to transfer your rights to someone
                    </strong>
                    . You may only transfer your rights or your obligations
                    under these terms to another person if we agree to this in
                    writing.
                  </li>
                  <li>
                    <strong>
                      Nobody else has any rights under these terms
                    </strong>
                    . These terms and any other terms expressly referred to in
                    them constitute the whole agreement between you and us and
                    supersede all previous discussions, correspondence,
                    negotiations, previous agreement, understanding or agreement
                    between us relating to the subject matter of any contract.
                  </li>
                  <li>
                    <strong>
                      If a court finds part of these terms illegal, the rest
                      will continue in force
                    </strong>
                    . Each of the clauses of these terms operates separately. If
                    any court or relevant authority decides that any of them are
                    unlawful, the remaining clauses will remain in full force
                    and effect.
                  </li>
                  <li>
                    <strong>
                      Even if we delay in enforcing these terms, we can still
                      enforce it later
                    </strong>
                    . If we do not insist immediately that you do anything you
                    are required to do under these terms, or if we delay in
                    taking steps against you in respect of your breaking these
                    terms, that will not mean that you do not have to do those
                    things and it will not prevent us taking steps against you
                    at a later date. For example, if you miss a payment and we
                    do not chase you but we continue to provide the products, we
                    can still require you to make the payment at a later date.
                  </li>
                  <li>
                    <strong>
                      Which laws apply to these terms and where you may bring
                      legal proceedings
                    </strong>
                    . These terms are governed by English law and you can bring
                    legal proceedings in respect of the products in the English
                    courts.
                  </li>
                  <li>
                    <strong>Headings</strong>. The headings in these terms are
                    included for convenience only and shall not affect their
                    interpretation.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </div>
      </div>
    );
  }
}

export default TermAndCondition;
